import { render, staticRenderFns } from "./ProposedRecommendation.vue?vue&type=template&id=764765ba&scoped=true"
import script from "./ProposedRecommendation.vue?vue&type=script&lang=js"
export * from "./ProposedRecommendation.vue?vue&type=script&lang=js"
import style0 from "./ProposedRecommendation.vue?vue&type=style&index=0&id=764765ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764765ba",
  null
  
)

export default component.exports